import type {IPerformanceDebugTrace} from "@pg-mono/performance-debug";

const TURNSTILE_SCRIPT_ID = "cloudflare-turnstile-script";
const TURNSTILE_SCRIPT_SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";

let scriptPromise: Promise<void> | null = null;

const isBrowser = typeof window !== "undefined" && typeof document !== "undefined";

export const loadTurnstileScript = (trace?: IPerformanceDebugTrace): Promise<void> => {
    if (!isBrowser) {
        trace?.mark("turnstile_script:skipped", {reason: "not_browser"});
        return Promise.resolve();
    }

    if (window.turnstile) {
        trace?.mark("turnstile_script:already_ready");
        return Promise.resolve();
    }

    if (scriptPromise) {
        trace?.mark("turnstile_script:reuse_pending_promise");
        return scriptPromise;
    }

    scriptPromise = new Promise<void>((resolve, reject) => {
        const existingScript = document.getElementById(TURNSTILE_SCRIPT_ID) as HTMLScriptElement | null;

        const resolveWhenReady = () => {
            if (window.turnstile) {
                trace?.mark("turnstile_script:load_done", {hasTurnstileApi: true});
                resolve();
                return;
            }

            trace?.mark("turnstile_script:load_failed", {reason: "missing_window_api"});
            reject(new Error("Turnstile script loaded without window.turnstile"));
        };

        if (existingScript) {
            trace?.mark("turnstile_script:wait_existing");
            existingScript.addEventListener("load", resolveWhenReady, {once: true});
            existingScript.addEventListener(
                "error",
                () => {
                    trace?.mark("turnstile_script:load_failed", {reason: "existing_script_error"});
                    reject(new Error("Turnstile script failed to load"));
                },
                {once: true}
            );

            return;
        }

        const script = document.createElement("script");
        script.id = TURNSTILE_SCRIPT_ID;
        script.src = TURNSTILE_SCRIPT_SRC;
        script.async = true;
        script.defer = true;
        script.addEventListener("load", resolveWhenReady, {once: true});
        script.addEventListener(
            "error",
            () => {
                trace?.mark("turnstile_script:load_failed", {reason: "new_script_error"});
                reject(new Error("Turnstile script failed to load"));
            },
            {once: true}
        );

        trace?.mark("turnstile_script:append");
        document.body.appendChild(script);
    }).catch((error) => {
        scriptPromise = null;
        document.getElementById(TURNSTILE_SCRIPT_ID)?.remove();
        trace?.mark("turnstile_script:reset_after_error");

        throw error;
    });

    return scriptPromise;
};
import type {IPerformanceDebugTrace} from "@pg-mono/performance-debug";

const TURNSTILE_SCRIPT_ID = "cloudflare-turnstile-script";
const TURNSTILE_SCRIPT_SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";

let scriptPromise: Promise<void> | null = null;

const isBrowser = typeof window !== "undefined" && typeof document !== "undefined";

export const loadTurnstileScript = (trace?: IPerformanceDebugTrace): Promise<void> => {
    if (!isBrowser) {
        trace?.mark("turnstile_script:skipped", {reason: "not_browser"});
        return Promise.resolve();
    }

    if (window.turnstile) {
        trace?.mark("turnstile_script:already_ready");
        return Promise.resolve();
    }

    if (scriptPromise) {
        trace?.mark("turnstile_script:reuse_pending_promise");
        return scriptPromise;
    }

    scriptPromise = new Promise<void>((resolve, reject) => {
        const existingScript = document.getElementById(TURNSTILE_SCRIPT_ID) as HTMLScriptElement | null;

        const resolveWhenReady = () => {
            if (window.turnstile) {
                trace?.mark("turnstile_script:load_done", {hasTurnstileApi: true});
                resolve();
                return;
            }

            trace?.mark("turnstile_script:load_failed", {reason: "missing_window_api"});
            reject(new Error("Turnstile script loaded without window.turnstile"));
        };

        if (existingScript) {
            trace?.mark("turnstile_script:wait_existing");
            existingScript.addEventListener("load", resolveWhenReady, {once: true});
            existingScript.addEventListener(
                "error",
                () => {
                    trace?.mark("turnstile_script:load_failed", {reason: "existing_script_error"});
                    reject(new Error("Turnstile script failed to load"));
                },
                {once: true}
            );

            return;
        }

        const script = document.createElement("script");
        script.id = TURNSTILE_SCRIPT_ID;
        script.src = TURNSTILE_SCRIPT_SRC;
        script.async = true;
        script.defer = true;
        script.addEventListener("load", resolveWhenReady, {once: true});
        script.addEventListener(
            "error",
            () => {
                trace?.mark("turnstile_script:load_failed", {reason: "new_script_error"});
                reject(new Error("Turnstile script failed to load"));
            },
            {once: true}
        );

        trace?.mark("turnstile_script:append");
        document.body.appendChild(script);
    }).catch((error) => {
        scriptPromise = null;
        document.getElementById(TURNSTILE_SCRIPT_ID)?.remove();
        trace?.mark("turnstile_script:reset_after_error");

        throw error;
    });

    return scriptPromise;
};
